import { z } from "zod"

export const PromptSchema = z.object({
  id: z.number(),
  title: z.string(),
  text: z.string(),
  created_at: z.string(),
  is_initial_processing: z.boolean(),
})

export const PromptFormSchema = z.object({
  text: z.string().nullish(),
})

export type Prompt = z.infer<typeof PromptSchema>
export type PromptForm = z.infer<typeof PromptFormSchema>
